var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg102 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BEE4F8",
  d: "M8.483 10a6.48 6.48 0 0 1 5.691 3.375 9.24 9.24 0 0 0-3.264 6.3h-.532c-2.04 0-3.85.988-4.977 2.512A6.483 6.483 0 0 1 8.483 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20.14 12.693a7.77 7.77 0 0 1 7.325 5.176l.414 1.172 1.228-.193q.454-.07.92-.07a5.885 5.885 0 1 1 0 11.768H10.378a4.687 4.687 0 1 1 0-9.375h1.907l.116-1.371a7.77 7.77 0 0 1 7.739-7.107"
}))));
export { Svg102 as ReactComponent };